"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Documents = exports.Spec = exports.Groups = exports.TITLE = exports.NAMESPACE = void 0;
const Compose = __importStar(require("../../openapi/compose"));
const admin_1 = require("../admin");
const dealer_1 = require("../dealer");
const frontend_1 = require("../frontend");
const pubsub_1 = require("../pubsub");
exports.NAMESPACE = 'Culligan.Api.V1.Spec';
exports.TITLE = 'Unified API - Version 1';
/**
 * Documentation-only contracts for the v1 routes served by Express.
 *
 * Every module under this directory exports `HttpApiGroup` values describing
 * legacy routes without handlers; register them here so they become part of
 * {@link Spec} and, through their `Audience` annotation, of {@link Documents}.
 */
exports.Groups = [
    admin_1.Auth.Spec,
    admin_1.Asset.Spec,
    admin_1.ClientApp.Spec,
    admin_1.Dealer.Spec,
    admin_1.Greg.Spec,
    admin_1.Metadata.Spec,
    admin_1.Metadata.WebhookSpec,
    admin_1.Notification.Spec,
    admin_1.User.Spec,
    admin_1.Device.Registry.Spec,
    admin_1.Device.Registry.WebhookSpec,
    admin_1.Device.Data.Spec,
    admin_1.Device.Command.Spec,
    admin_1.Device.CommandJob.Spec,
    admin_1.Device.OtaBuild.Spec,
    admin_1.Device.OtaGroup.Spec,
    admin_1.Device.OtaJob.Spec,
    dealer_1.Profile.Spec,
    frontend_1.Dealer.Spec,
    frontend_1.Device.Spec,
    frontend_1.Metadata.Spec,
    frontend_1.Notification.Spec,
    frontend_1.Privacy.Spec,
    frontend_1.Account.Spec,
    pubsub_1.Device.Spec,
    pubsub_1.Job.Spec,
    pubsub_1.PelicanBridge.Spec,
    frontend_1.Auth.Spec,
];
const make = (groups, title = exports.TITLE) => Compose.makeRoot({ id: 'v1', version: Compose.Version.V1, title }, groups);
/** The complete v1 documentation root (never served). */
exports.Spec = make(exports.Groups);
/** One v1 document per audience (admin, user, device, fleet, system). */
exports.Documents = Compose.documents(exports.Groups, (audience, groups) => make(groups, `${exports.TITLE} - ${Compose.documentTitle(audience)}`));
//# sourceMappingURL=index.js.map